import { useProfileStore } from '@/store/useProfileStore.ts';
import { WebSocketMessage } from '@/providers/WebSocketProvider/WebSocketProvider.tsx';
import { PaywallTypes, TransactionSource } from '@/enums/apiEnums.ts';
import { SUBSCRIPTION_GROUPS } from '@/constants/subscription_groups.ts';
import PurchaseController from '@/api/purchases/purchases.ts';
import { catchErrors } from '@/utils/sentry-monitor.tsx';

export const handleSubscriptionPurchase = async (ctxData: WebSocketMessage) => {
  const { updatePremium } = useProfileStore.getState();

  const isBuyPremium =
    [TransactionSource.SOURCE_SUBSCRIBED].includes(
      ctxData.subscription_purchase_event?.transaction
        .source as TransactionSource
    ) &&
    ctxData.subscription_purchase_event?.transaction.product.subscription
      .group === SUBSCRIPTION_GROUPS.premium;

  if (isBuyPremium) {
    try {
      const subscriptions = await PurchaseController.getSubscription();

      const premiumPurchase = subscriptions.purchases?.find(
        (p) =>
          p.product.type === PaywallTypes.TYPE_SUBSCRIPTION &&
          p.product.subscription_details?.group === SUBSCRIPTION_GROUPS.premium
      );

      updatePremium({
        duration:
          premiumPurchase?.product.subscription_details
            ?.service_duration_days ?? 0,
        expireTime: premiumPurchase?.expiry_time ?? null
      });
    } catch (e) {
      catchErrors(e);
    }
  }
};
